import React from 'react';
import { mui } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import RelaxOrder from './relax-order';
import NumericField from '../../numeric-field';
import constraintInputNames from '../optimizer-utils/input-names';

type MaximumTcostProps = {
  params: types.optimizer.MaximumTcostDraft;
  setParams: (_params: types.optimizer.MaximumTcostDraft) => void;
  readOnly: boolean;
};

const MaximumTcost = ({ params, setParams, readOnly }: MaximumTcostProps) => {
  return (
    <mui.core.Box p={2}>
      <mui.core.Grid container spacing={4}>
        <mui.core.Grid size={{ xs: 12, md: 4 }}>
          <NumericField
            textFieldProps={{
              label: constraintInputNames.maximum_t_cost_upper_bound,
              fullWidth: true,
              variant: 'outlined',
              size: 'small',
              required: true,
            }}
            disabled={readOnly}
            value={params.upper_bound}
            setValue={(v) => setParams({ ...params, upper_bound: v })}
          />
        </mui.core.Grid>

        <mui.core.Grid size={{ xs: 12, md: 4 }}>
          <RelaxOrder params={params} setParams={setParams} disabled={readOnly} />
        </mui.core.Grid>
      </mui.core.Grid>
    </mui.core.Box>
  );
};

export default MaximumTcost;
